import React from "react";
import { Card, CardHeader, CardContent, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function PaymentSection({ formData, handleText }) {
  const { t } = useTranslation("products");
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.payment")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <TextField
          label={t("form.paymentRules")}
          name="pagamento_regras"
          value={formData.pagamento_regras}
          onChange={handleText}
          fullWidth
          multiline
          minRows={2}
          placeholder="—"
        />
      </CardContent>
    </Card>
  );
}
